// src/components/Login.js

import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AuthContext } from '../contexts/AuthContext';
const backendKey = process.env.REACT_APP_backend_key;
const myendpoint = process.env.REACT_APP_backend;
const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  useEffect(() => {
    // Verificar si las cookies están presentes después de la redirección
    const fullName = Cookies.get('fullName');
    const email = Cookies.get('email');

    if (fullName && email) {
      login(fullName, email);
      navigate('/'); // Redirigir al panel principal
    }
  }, [login, navigate]);

  const handleLogin = () => {
    // Iniciar autenticación con Google
    window.location.href = myendpoint+'/login-social'; // Ajusta la URL según tu configuración
  };

  return (
    <div className="login-container">
      <h2>Iniciar Sesión</h2>
      <button onClick={handleLogin}>Iniciar con Google</button>
    </div>
  );
};

export default Login;
